import { Component, input } from '@angular/core';

@Component({
  selector: 'app-spinner',
  standalone:true,
  templateUrl: './spinner.component.html',
  styleUrl: './spinner.component.scss'
})
export class SpinnerComponent {
  visibleSpinner = input<boolean>(true);
  trigger = input<boolean>(true);
  message = input<string>('');
}
